;(function (angular, _) {
  'use strict'

  angular.lowercase = angular.$$lowercase
  angular
    .module('kilo.config')
    .run(Bootstrap)

  Bootstrap.$inject = [
    // Auth
    'zlAuth',

    // Angular
    '$timeout', '$uibModalStack', '$rootScope', '$state',

    // Services
    'SidebarService', 'SnackService', 'SessionService',

    // Resolve
    'amMoment', 'hotkeys', 'shortcuts'

  ]

  function Bootstrap (
    // Auth
    zlAuth,

    // Angular
    $timeout, $uibModalStack, $rootScope, $state,

    // Services
    SidebarService, SnackService, SessionService,

    // Resolve
    amMoment, hotkeys, shortcuts

  ) {
    hotkeys.get('?').description = 'Afficher / Cacher ce menu'
    _.each(shortcuts, function (s) {
      s.callback = function () {
        if (
          !$state.is('invoice.show') &&
          !$state.is('invoice.new') &&
          !$state.is('quote.show') &&
          !$state.is('quote.new') &&
          !$state.is('product.show') &&
          !$state.is('product.new') &&
          !$state.is('creditnote.show') &&
          !$state.is('creditnote.new') &&
          !$uibModalStack.getTop()
        ) {
          // Don't do anything if we're in an edit state or if a modal is open
          $state.go(s.state)
        }
      }
      hotkeys.add(s)
    })
    amMoment.changeLocale('fr')

    $rootScope.$state = $state

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      if (toState.restrict && toState.restrict === 'admin' && !SessionService.isAdmin()) {
        event.preventDefault()
        $state.go('invoice.list')
      }
      if (!event.defaultPrevented) {
        $rootScope.loadingPage = true
        if (SidebarService.visible) {
          SidebarService.toggle()
        }
        $rootScope.loadingPage = true
      }
    })

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      console.error('ui router error: ', error)
    })

    $rootScope.$on('$stateNotFound', function () {
      console.error('ui-router, state not found')
    })

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      if (toState.resolve) $rootScope.loadingPage = false
      document.body.scrollTop = document.documentElement.scrollTop = 0
      $uibModalStack.dismissAll()
    })

    $rootScope.$on('httpNotResponding', function (event, data) {
      if (data.title === 'Autorisation refusée') {
        zlAuth.disconnect()
      }

      if (data.status === 409) {
        SnackService.snack({
          text: 'Cette ressource a déjà été modifié par un autre utilisateur. Veuillez copier vos données puis actualiser l\'application.',
          delay: 6000,
          color: 'red',
          icon: 'mdi-alert-outline'
        })
        return
      }

      if (data.status === 422) {
        return
      }

      $timeout(function () {
        $rootScope.globalError = {
          icon: 'mdi-power-plug',
          title: data.title,
          description: data.message,
          status: data.status
        }
      }, 1000)
    })
  }
})(window.angular, window._)
